import BulkDeleteModal from "../../../../components/BulkDeleteModal";
import useTranslations from "../../../../core/i18n/useTranslations";
import { deleteRespondentGroup } from "../../../../core/api/responsecenters/responsecenters";

export const DeleteRespondentGroupModal = ({
  arcId,
  isOpen,
  ids,
  onClose,
  onDelete,
}: {
  arcId: number;
  isOpen: boolean;
  ids: number[];
  onClose: () => void;
  onDelete: (success: boolean) => void;
}) => {
  const t = useTranslations();

  return (
    <BulkDeleteModal
      isOpen={isOpen}
      onClose={onClose}
      onDelete={onDelete}
      ids={ids.map((id) => id.toString())}
      labels={{
        single: t("AlarmReceptions:respondent_group_type"),
        multi: t("AlarmReceptions:respondent_group_type_multi"),
      }}
      apiFunc={(id, authReq) =>
        deleteRespondentGroup(arcId, id as any, authReq) as any
      }
    />
  );
};
